<template>
    <v-list class="rounded-xl border-none flex-grow-0 flex-shrink-1">
        <v-list-item v-if="startDate && endDate">
            <v-list-item-title
                ><b>{{ periodTitle }}</b></v-list-item-title
            >
            <v-list-item-subtitle>{{ period }}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-if="amountDeclared">
            <v-list-item-title><b>Montant déclaré</b></v-list-item-title
            ><v-list-item-subtitle>{{
                newCommonFormatCurrency(amountDeclared, undefined)
            }}</v-list-item-subtitle></v-list-item
        >
        <v-list-item v-if="paymentsInfo">
            <v-list-item-title><b>Montant payé</b></v-list-item-title
            ><v-list-item-subtitle>{{
                newCommonFormatCurrency(paymentsInfo.amountPaid, undefined)
            }}</v-list-item-subtitle></v-list-item
        >
        <template v-if="paymentsInfo">
            <v-list-item v-for="payment in paymentsInfo.paymentsList" :key="payment.iban">
                <v-list-item-subtitle> {{ payment.iban }} </v-list-item-subtitle
                ><v-list-item-subtitle> {{ payment.bic }} </v-list-item-subtitle
                ><v-list-item-subtitle>
                    {{ newCommonFormatCurrency(payment.amount, undefined) }}
                </v-list-item-subtitle></v-list-item
            >
        </template>
        <v-list-item v-if="translatedStatus">
            <v-list-item-title><b>Statut</b></v-list-item-title
            ><v-list-item-subtitle class="line-clamp-2">{{
                translatedStatus
            }}</v-list-item-subtitle></v-list-item
        >
        <v-list-item v-if="translatedSendDate">
            <v-list-item-title><b>Date d'envoi</b></v-list-item-title
            ><v-list-item-subtitle>{{ translatedSendDate }}</v-list-item-subtitle></v-list-item
        >
        <v-list-item v-if="mtaeId">
            <v-list-item-title><b>EDI</b></v-list-item-title
            ><v-list-item-subtitle class="line-clamp-2">{{
                mtaeId
            }}</v-list-item-subtitle></v-list-item
        >
        <v-list-item v-if="errors.length">
            <v-list-item-title><b>Erreurs</b></v-list-item-title
            ><v-list-item-subtitle
                v-for="(error, index) in errors"
                :key="index"
                class="line-clamp-5"
            >
                {{ error.num }} - {{ error.detail }}
            </v-list-item-subtitle></v-list-item
        >
    </v-list>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import moment from "moment-timezone";
import { newCommonFormatCurrency } from "../../../../../backend/src/common/services/mathServices";

@Component({})
export class DeclarationManagerInfo extends Vue {
    @Prop({ default: null }) startDate: string;
    @Prop({ default: null }) endDate: string;
    @Prop({ default: 0 }) amountDeclared: number;
    @Prop({ default: null }) paymentsInfo: any;
    @Prop({ default: null }) translatedStatus: string;
    @Prop({ default: null }) translatedSendDate: string;
    @Prop({ default: null }) mtaeId: string;
    @Prop({ default: [] }) errors: any;

    get periodTitle(): string {
        if (this.startDate === this.endDate) {
            return "Echéance";
        }
        return "Période";
    }

    get period(): string {
        if (this.startDate === this.endDate) {
            return this.formatDate(this.startDate);
        }
        return `${this.formatDate(this.startDate)} - ${this.formatDate(this.endDate)}`;
    }

    formatDate(date: string) {
        return moment(date).format("D MMM YYYY");
    }

    newCommonFormatCurrency(value, option) {
        return newCommonFormatCurrency(value, option);
    }
}

export default toNative(DeclarationManagerInfo);
</script>
